import snackbarReducer from './SnackbarReducer';
import groupReducer from './GroupReducer';
import { combineReducers } from 'redux';

const reducer = combineReducers({
  snackbar: snackbarReducer,
  group: groupReducer
});

export default reducer;
